const studioEndpoints = {
  createComponent: { method: "POST", path: "/studio/components" },
  getComponent: (componentId) => ({
    method: "GET",
    path: `/studio/components/${componentId}`,
  }),
  updateComponent: (componentId) => ({
    method: "PATCH",
    path: `/studio/components/${componentId}`,
  }),
  deleteComponent: (componentId) => ({
    method: "DELETE",
    path: `/studio/components/${componentId}`,
  }),
  getComponents: { method: "GET", path: "/studio/components" },
  createAnimation: { method: "POST", path: "/studio/animations" },
  getAnimation: (animationId) => ({
    method: "GET",
    path: `/studio/animations/${animationId}`,
  }),
  updateAnimation: (animationId) => ({
    method: "PATCH",
    path: `/studio/animations/${animationId}`,
  }),
  updateAudioMarkers: (animationId) => ({
    method: "PATCH",
    path: `/studio/animations/${animationId}/audio-markers`,
  }),
  getAnimations: { method: "GET", path: "/studio/animations" },
  createAnimationComponent: (animationId) => ({
    method: "POST",
    path: `/studio/animations/${animationId}/components`,
  }),
  deleteAnimationComponent: (animationId, animationComponentId) => ({
    method: "DELETE",
    path: `/studio/animations/${animationId}/components/${animationComponentId}`,
  }),
  updateAnimationComponent: (animationId, animationComponentId) => ({
    method: "PATCH",
    path: `/studio/animations/${animationId}/components/${animationComponentId}`,
  }),
  getAnimationComponents: (animationId) => ({
    method: "GET",
    path: `/studio/animations/${animationId}/components`,
  }),
  createTimeline: (animationId) => ({
    method: "POST",
    path: `/studio/animations/${animationId}/timelines`,
  }),
  deleteTimeline: (animationId, timelineId) => ({
    method: "DELETE",
    path: `/studio/animations/${animationId}/timelines/${timelineId}`,
  }),
  getTimelines: (animationId) => ({
    method: "GET",
    path: `/studio/animations/${animationId}/timelines`,
  }),
  createConnector: (animationId) => ({
    method: "POST",
    path: `/studio/animations/${animationId}/connectors`,
  }),
  deleteConnector: (animationId, connectorId) => ({
    method: "DELETE",
    path: `/studio/animations/${animationId}/connectors/${connectorId}`,
  }),
  createScript: (animationId) => ({
    method: "POST",
    path: `/studio/animations/${animationId}/scripts`,
  }),
  saveScriptDraft: (animationId) => ({
    method: "POST",
    path: `/studio/animations/${animationId}/scripts/draft`,
  }),
  previewScript: (animationId) => ({
    method: "POST",
    path: `/studio/animations/${animationId}/scripts/preview`,
  }),
  getScript: (animationId) => ({
    method: "GET",
    path: `/studio/animations/${animationId}/scripts/latest`,
  }),
  getScripts: (animationId) => ({
    method: "GET",
    path: `/studio/animations/${animationId}/scripts`,
  }),
  uploadAsset: (animationId) => ({
    method: "POST",
    path: `/studio/animations/${animationId}/assets`,
  }),
  getAssets: (animationId) => ({
    method: "GET",
    path: `/studio/animations/${animationId}/assets`,
  }),
  deleteAsset: (animationId, assetId) => ({
    method: "DELETE",
    path: `/studio/animations/${animationId}/assets/${assetId}`,
  }),
  renameAsset: (animationId, assetId) => ({
    method: "PATCH",
    path: `/studio/animations/${animationId}/assets/${assetId}`,
  }),
  trimAsset: (animationId, assetId) => ({
    method: "POST",
    path: `/studio/animations/${animationId}/assets/${assetId}/trim`,
  }),
  startExport: (animationId) => ({
    method: "POST",
    path: `/export/${animationId}`,
  }),
  getExportStatus: (jobId) => ({
    method: "GET",
    path: `/export/status/${jobId}`,
  }),
  downloadExport: (jobId) => ({
    method: "GET",
    path: `/export/download/${jobId}`,
  }),
};

export default studioEndpoints;
